function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// mui imports
import MuiInputBase from "@mui/material/InputBase";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
// @limitless
import ErrorIcon from "@limitless/icons/ExclamationCircle";
import { useTranslation } from "@limitless/common/hooks";
import InputLabel from "../input-label/InputLabel";
const TextField = ({
  value,
  label = "",
  placeholder = "Type here",
  errorText = "",
  helperText,
  fullWidth = true,
  endAdornment,
  required = false,
  error = false,
  disabled = false,
  // eslint-disable-next-line no-unused-vars
  defaultValue,
  // Not used, components always controlled. Stripped out of ...rest here.
  ...rest
}) => {
  const {
    id = `${label.trim().toLowerCase() || "no_label"}_textField`
  } = {
    ...rest
  };
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(FormControl, {
    variant: "standard",
    error: error,
    fullWidth: fullWidth,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(InputLabel, {
    label: label,
    id: id,
    required: required
  }), /*#__PURE__*/React.createElement(MuiInputBase, _extends({
    id: id,
    placeholder: t(placeholder),
    value: value,
    autoComplete: "off",
    endAdornment: error ? /*#__PURE__*/React.createElement(ErrorIcon, {
      sx: {
        color: theme => theme.palette.error.main
      }
    }) : endAdornment || null,
    sx: {},
    multiline: false,
    rows: 0,
    shrink: +false,
    variant: "outlined",
    "aria-labelledby": `${id}-label`
  }, rest)), /*#__PURE__*/React.createElement(FormHelperText, {
    id: `${id}-helper`
  }, error ? t(errorText) : t(helperText)));
};
TextField.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  errorText: PropTypes.string,
  fullWidth: PropTypes.bool,
  endAdornment: PropTypes.node,
  required: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.any
};
export default TextField;